import * as React from 'react'

import { Input } from '@syconium/little-miss-figgy'

import { useTranslation } from '../../../../../../app/_providers/TranslationProvider.client'
import { trackEvent } from '../../../../../../lib/analytics'

import { CtaButton } from './styles'
import { useWaitlistForm } from './useWaitlistForm'

export interface WaitlistFormProps {}

export const WaitlistForm: React.FC<WaitlistFormProps> = () => {
  const { waitlist: waitlistCopy } = useTranslation()
  const waitlistForm = useWaitlistForm()

  return (
    <form onSubmit={waitlistForm.handleSubmit} noValidate>
      <Input
        isInvalid={!!(waitlistForm.touched.emailAddress && waitlistForm.errors.emailAddress)}
        messageWhenInvalid={waitlistForm.errors.emailAddress}
        name='emailAddress'
        onChange={waitlistForm.handleChange}
        placeholder={waitlistCopy.modal.form.email.placeholder}
        type='email'
        {...trackEvent({
          action: 'change',
          category: 'notify-me email form',
          value: waitlistForm.values.emailAddress,
        })}
        value={waitlistForm.values.emailAddress}
      />
      {/* TODO: Replace button with anchor tag or use an actual click function. */}
      <CtaButton
        onClick={() => null}
        block
        type='submit'
        {...trackEvent({
          category: 'notify-me cta',
          action: 'click',
        })}
      >
        {waitlistCopy.modal.form.cta}
      </CtaButton>
    </form>
  )
}

export default WaitlistForm
